import { ReactComponent as CopyIcon } from '@elementary/common-ui/assets/copy.svg';
import {
  CodeEditor,
  Expandable,
  FlexCenter,
} from '@elementary/common-ui/components';
import { CircularProgress } from '@mui/material';
import ExceptionCard from 'shared/components/ExceptionCard';
import useSnackbar from 'shared/hooks/useSnackbar';
import useSelectedWarehouseType from 'shared/hooks/useSelectedWarehouseType';
import { SourceType } from 'shared/types';
import useTestOverviewExecution from 'shared/hooks/useTestOverviewExecution';
import { ModelFailureExecution } from 'shared/types/execution';
import ExecutionOverview from 'shared/components/ExecutionOverview';
import PanelError from 'shared/components/PanelError';
import { DetailsComponentProps } from 'shared/components/ExecutionHistory';

const ModelFailureDetails = ({ id }: Pick<DetailsComponentProps, 'id'>) => {
  const { openSnackbar } = useSnackbar();
  const warehouseType = useSelectedWarehouseType();

  const { data, error, isFetching } =
    useTestOverviewExecution<ModelFailureExecution>(id, SourceType.MODEL);

  if (isFetching || error) {
    return (
      <FlexCenter sx={{ height: '100%', padding: '0 24px' }}>
        {error ? (
          <PanelError
            error={error as Error}
            errorName="ApiError"
            page={'ModelFailureDetails'}
          />
        ) : (
          <CircularProgress size={32} />
        )}
      </FlexCenter>
    );
  }

  return (
    <>
      <ExecutionOverview data={data as ModelFailureExecution} />

      {data?.exception && <ExceptionCard exception={data?.exception} />}

      {data?.query && (
        <Expandable
          title="Query"
          defaultExpanded
          actionButtonTitle="Copy result query"
          actionButtonIcon={<CopyIcon width={16} />}
          onActionButtonClick={() => {
            navigator.clipboard.writeText(data.query);
            openSnackbar({ message: 'Copied to clipboard' });
          }}
        >
          <CodeEditor
            mode="sql"
            warehouseType={warehouseType}
            value={data.query}
            readOnly
          />
        </Expandable>
      )}
    </>
  );
};

export default ModelFailureDetails;
